import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import { PartnerService } from 'src/app/shared/services/partner.service';

@Component({
  selector: 'app-data-management-create-show-modal',
  templateUrl: './data-management-create-show-modal.component.html',
  styleUrls: ['./data-management-create-show-modal.component.scss']
})
export class DataManagementCreateShowModalComponent implements OnInit {

  title: string;
  description: string;
  partnerGroups: any;
  selectedPartnerGroup: any;

  @ViewChild('autosize') autosize: CdkTextareaAutosize;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DataManagementCreateShowModalComponent>,
    private partnerService: PartnerService
    ) { }

  ngOnInit() {
    if (this.data?.title) {
      this.title = this.data.title;
    }
    if (this.data?.partnerGroups) {
      this.partnerGroups = this.data.partnerGroups;
    }

  }

  trackById(_: number, item: any) {
    return item.id;
  }

  close(): void {
    this.dialogRef.close();
    this.partnerService.notifyModalClosed(); // Notify modal closed  
  }

  cancel(): void {
    this.dialogRef.close();
  }

  createProShow(title: string, description: string, id?: any, selectedPartnerGroup?: any) {
    this.partnerService.updateProShow(id, title, description, selectedPartnerGroup?.id).subscribe((res: any) => {
      this.close();
    });
  }
}
